// Charge la base commune
import './common.js'

// Scripts librairies
import { dtectMap } from './js/libs/utils'

// Agencies map
async function getAgenciesMap($f) {
  $f.load()
  import(/* webpackChunkName: "agenciesMap", webpackPrefetch: true */ './js/components/agenciesMap.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Contact Form
async function getCForm($f) {
  import(/* webpackChunkName: "contactForm" */ './js/components/contactForm.js').then(() => {
    // Global Waypoint
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Location Form
async function getLForm($f) {
  $f.load()
  import(/* webpackChunkName: "locationForm" */ './js/components/locationForm.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // formulaire de contact
  const $c = $('form[name="cForm"]')
  $c.waypoint(
    function () {
      $c.load()
      getCForm($c)
      this.destroy()
    },
    {
      offset: '100%',
    }
  )

  // gestion de la localisation
  const $c2 = $('form[name="lForm"]')
  if ($c2.length) {
    $c2.waypoint(
      function () {
        getLForm($c2)
        this.destroy()
      },
      {
        offset: '100%',
      }
    )
  }

  // à exécuter une fois la GMap API correctement chargée
  dtectMap(function () {
    // gestion de la carte des agences
    const $c1 = $('#map-agencies').length ? $('#map-agencies') : $('#map-detail')
    if ($c1.length) {
      $c1.waypoint(
        function () {
          getAgenciesMap($c1)
          this.destroy()
        },
        {
          offset: '100%',
        }
      )
    }
  })
})
